module.exports = __webpack_public_path__ + "img/first-name_icon.d5682d22.svg";